import { useState } from "react";
import { navLinks } from "@/mocks/content";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const go = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    setOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/70 bg-background-50/90 backdrop-blur-md">
      <nav className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-4 md:px-6">
        <a
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-2"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-sparkling-2-fill text-lg"></i>
          </span>
          <span className="font-heading text-xl text-foreground-950">火影黄本子</span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              onClick={(e) => {
                e.preventDefault();
                go(link.id);
              }}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#subscribe"
            onClick={(e) => {
              e.preventDefault();
              go("subscribe");
            }}
            className="ml-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            订阅新梗
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-700 hover:bg-background-200 md:hidden"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  go(link.id);
                }}
                className="rounded-md px-3 py-2 text-sm text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={(e) => {
                e.preventDefault();
                go("subscribe");
              }}
              className="mt-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-center text-sm text-background-50 hover:bg-primary-600"
            >
              订阅新梗
            </a>
          </div>
        </div>
      )}
    </header>
  );
}